module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "DakaDownLoadView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=DakaDownLoadView!./src/pages/Map/index.js
// module id = 1290
// module chunks = 431